
import Vue from 'vue'
import Router from 'vue-router'

import RouteView from '@/components/shared/RouteView'

import Login from '@/views/login/Login'
import LoginForm from '@/components/login/LoginForm'
import LoginPasswordForm from '@/components/login/LoginPasswordForm'

import Dashboard from '@/views/Dashboard'
// import Commerce from '@/views/Commerce'
import CommerceInfo from '@/views/CommerceInfo'
import FacturacionTable from '@/components/CommerceInfo/consultas/FacturacionTable'
import RecibosTable from '@/components/CommerceInfo/consultas/RecibosTable'

import Cadena from '@/views/Cadena'
import Usuarios from '@/views/Usuarios'
import DetalleMovimientos from '@/views/DetalleMovimientos'
import Loyalty from '@/views/loyalty/Loyalty'
import LoyaltyPrograms from '@/views/loyalty/LoyaltyPrograms'
import LoyaltyAccounts from '@/views/loyalty/LoyaltyAccounts'
import LoyaltyCoupons from '@/views/loyalty/LoyaltyCoupons'
import LoyaltyAnalytics from '@/views/loyalty/LoyaltyAnalytics'
import AnalyticsAccounts from '@/views/loyalty/AnalyticsAccounts'
import AnalyticsClients from '@/views/loyalty/AnalyticsClients'
import TemplatesDetails from '@/views/loyalty/TemplatesDetails'
import CouponsAsing from '@/views/loyalty/CouponsAsing'
import CouponsAsingAccounts from '@/views/loyalty/CouponsAsingAccounts'
// import config from '@/config'

Vue.use(Router)

/* function to add breadcrumbs to a view */
const setBreadcrumbParams = to => {
  const breadcrumbParams = {
    userInfo: sessionStorage.getItem('userInfo'),
    randomStr: sessionStorage.getItem('randomStr')
  }
  to.matched.forEach(e => {
    for (const param in breadcrumbParams) {
      if (e.meta.breadcrumbParam === param) {
        to.params[e.meta.breadcrumbParam] = breadcrumbParams[param]
      }
    }
  })
}

const route = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      redirect: { name: 'login-form' },
      children: [
        {
          path: '',
          name: 'login-form',
          component: LoginForm
        },
        {
          path: 'password',
          name: 'password-form',
          component: LoginPasswordForm
        }
      ]
    },
    {
      path: '/',
      name: 'Home',
      component: Dashboard,
      meta: {
        breadcrumbTextKey: 'home',
        private: true
      }
    }, {
      path: '/commerce/',
      name: 'Comerce',
      component: RouteView,
      props: true,
      redirect: {
        name: 'Commerce'
      },
      meta: {
        // breadcrumbTextKey: 'comercios',
        breadcrumbParam: 'chain',
        private: true
      },
      children: [{
        path: '/commerce/:id',
        name: 'Commerce',
        component: RouteView,
        props: true,
        redirect: {
          name: 'CommerceDetail'
        },
        meta: {
          // breadcrumbTextKey: 'comercio',
          breadcrumbParam: 'commerce',
          private: false
        },
        children: [{
          path: '/',
          component: CommerceInfo,
          name: 'CommerceDetail'
        }, {
          path: '/commerce/:id/facturas',
          component: FacturacionTable,
          name: 'FacturacionTable',
          meta: {
            breadcrumbTextKey: 'facturas',
            private: true
          }
        }, {
          path: '/commerce/:id/recibos',
          component: RecibosTable,
          name: 'RecibosTable',
          meta: {
            breadcrumbTextKey: 'recibos',
            private: true
          }
        }]
      }]
    }, {
      path: '/cadena/:id',
      name: 'Cadena',
      component: Cadena,
      meta: {
        breadcrumbTextKey: 'dashboard',
        private: true
      }
    }, {
      path: '/usuarios/',
      name: 'Usuarios',
      component: Usuarios,
      meta: {
        breadcrumbTextKey: 'dashboard',
        private: true
      }
    }, {
      path: '/detallemovimientos/',
      name: 'DetalleMovimientos',
      component: DetalleMovimientos,
      meta: {
        breadcrumbTextKey: 'movimiento',
        private: true
      }
    }, {
      path: '/loyalty/',
      component: RouteView,
      name: 'Loyalty',
      meta: {
        breadcrumbTextKey: 'loyalty',
        private: true
      },
      redirect: {
        name: 'LoyaltyView'
      },
      children: [
        {
          path: '',
          component: Loyalty,
          name: 'LoyaltyView'
        },
        {
          path: '/loyalty/programs',
          name: 'LoyaltyPrograms',
          component: LoyaltyPrograms,
          meta: {
            breadcrumbTextKey: 'programs',
            private: true
          }
        },
        {
          path: '/loyalty/accounts',
          name: 'LoyaltyAccounts',
          component: LoyaltyAccounts,
          meta: {
            breadcrumbTextKey: 'accounts',
            private: true
          }
        },
        {
          path: '/loyalty/coupons',
          component: RouteView,
          name: 'coupons',
          meta: {
            breadcrumbTextKey: 'coupons',
            private: true
          },
          redirect: {
            name: 'LoyaltyCoupons'
          },
          children: [
            {
              path: '',
              component: LoyaltyCoupons,
              name: 'LoyaltyCoupons'
            },
            {
              path: '/Templates',
              name: 'TemplatesDetails',
              component: TemplatesDetails,
              meta: {
                breadcrumbTextKey: 'TemplatesDetails',
                private: true
              }
            },
            {
              path: '/CouponsAsing',
              name: 'CouponsAsing',
              component: CouponsAsing,
              meta: {
                breadcrumbTextKey: 'CouponsAsing',
                private: true
              }
            },
            {
              path: '/CouponsAsingAccounts',
              name: 'CouponsAsingAccounts',
              component: CouponsAsingAccounts,
              meta: {
                breadcrumbTextKey: 'CouponsAsing',
                private: true
              }
            }
          ]
        },
        {
          path: '/loyalty/analytics',
          component: RouteView,
          name: 'analytics',
          meta: {
            breadcrumbTextKey: 'Analytics',
            private: true
          },
          redirect: {
            name: 'LoyaltyAnalytics'
          },
          children: [
            {
              path: '/loyalty/analytics',
              component: LoyaltyAnalytics,
              name: 'LoyaltyAnalytics',
              meta: {
                private: true
              }
            },
            {
              path: '/loyalty/analytics/accounts',
              component: AnalyticsAccounts,
              name: 'AnalyticsAccounts',
              meta: {
                breadcrumbTextKey: 'accounts',
                private: true
              }
            },
            {
              path: '/loyalty/analytics/clients',
              component: AnalyticsClients,
              name: 'AnalyticsClients',
              meta: {
                breadcrumbTextKey: 'clients',
                private: true
              }
            }
          ]
        }
      ]
    }
  ]
})

route.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.private)) {
    if (!sessionStorage.getItem('sessionToken')) {
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
  setBreadcrumbParams(to)
})

export default route
